import { Injectable } from '@angular/core';
import { KalgudiDialogsService } from '@kalgudi/common';
import { KalgudiStreamData } from '@kalgudi/core';
import { KalgudiStreamS3FetchService } from '@kalgudi/social';
import { KalgudiDialogResult, ProgramQaFullDetails } from '@kalgudi/types';
import { combineLatest, Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { MobileProgramQaFormComponent } from '../components/mobile-program-qa-form/mobile-program-qa-form.component';
import { KalgudiProgramQaApiService } from './kalgudi-program-qa-api.service';

@Injectable()
export class KalgudiProgramQaService {

  constructor(
    private api: KalgudiProgramQaApiService,
    private s3Fetch: KalgudiStreamS3FetchService,
    private dialogService: KalgudiDialogsService,
  ) { }

  /**
   * Gets, stream of Qa activities performed under specified program.
   *
   * @param entityId Page/program id
   * @param offset Offset to fetch records
   * @param limit Number of records to fetch
   */
  getQaStream(entityId: string, offset: number, limit: number, fromDate?: string, toDate?: string): Observable<KalgudiStreamData> {

    return this.api.fetchStream(entityId, offset, limit, fromDate, toDate)
      .pipe(

        // Merge map will wait for response from all observables mapped by the `fetchStreamItem()`
        // method.
        mergeMap(r =>

          // Combine response from all s3 items
          combineLatest(
            r.map(s => this.s3Fetch.fetchStreamItem<ProgramQaFullDetails>(s as any, s.url, s.event))
          )
        ),

        // Map the complete stream response
        map(items => ({ items }))
      );
  }

  // Opens program qa form for mobil view
  openMobileQaForm(): Observable<KalgudiDialogResult> {
    return this.dialogService.openMobileDialog(MobileProgramQaFormComponent, {
      data: { },
      title: 'Ask question',
    });
  }
}
